import { render } from "./SwapTypeChart.vue?vue&type=template&id=fa63ae72"
import script from "./SwapTypeChart.vue?vue&type=script&lang=js"
export * from "./SwapTypeChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Charts/SwapTypeChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fa63ae72"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fa63ae72', __exports__)) {
    api.reload('fa63ae72', __exports__)
  }
  
  module.hot.accept("./SwapTypeChart.vue?vue&type=template&id=fa63ae72", () => {
    api.rerender('fa63ae72', render)
  })

}


export default __exports__